import * as React from 'react';
import './index.scss'

const FeatureCreator = ({ projectData }) => {
    let {
        features,
    } = projectData

    return features.map((feature, index) => {
        const { title, image } = feature
        return (
            <React.Fragment key={'feature', index}>
                <hr className="hline" />
                <section className="project-page-feature">
                    { title && <div className="project-page-feature-title">{title}</div> }
                    {image && <FeatureImage image={image} /> }
                </section>

            </React.Fragment>
        )
    })

}

export default FeatureCreator


const FeatureImage = ({ image }) => {
    if (Array.isArray(image)) {
      return image.map(({ link, vertical }) => (
        <img
          className={getImageClass(vertical)}
          src={link}
          alt="project-feature"
        />
      ));
    } else {
      const { link, vertical, size } = image;
      return (
        <img
          className={getImageClass(vertical, size)}
          src={link}
          alt="project-feature"
        />
      );
    }
  };

  const getImageClass = (vertical, size = 'default') => {
    const orientation = vertical
      ? `project-image--vertical`
      : `project-image--horizontal`;
    return `project-image ${orientation} project-image--${size}`;
  };